import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Multiselect from '@rio-cloud/rio-uikit/Multiselect';

import { type ConnectionType, ConnectionTypes } from '../../services/partnerNetwork.types';
import { useRestrictConnection } from '../../routes/routeHooks';

const allConnectionTypes = [ConnectionTypes.ORDER_EXCHANGE, ConnectionTypes.RENTAL];

type ConnectionTypeFilter = {
    onConnectionTypeChange?: (connectionTypes: ConnectionType[]) => void;
};

const ConnectionTypeFilter = ({ onConnectionTypeChange = () => {} }: ConnectionTypeFilter) => {
    const [selectedConnectionTypes, setSelectedConnectionTypes] = useState(allConnectionTypes);

    const restrictedConnectionType = useRestrictConnection();

    useEffect(() => {
        onConnectionTypeChange(restrictedConnectionType ? [restrictedConnectionType] : allConnectionTypes);
        setSelectedConnectionTypes(restrictedConnectionType ? [restrictedConnectionType] : allConnectionTypes);
    }, [restrictedConnectionType]);

    const connectionTypeOptions = [
        {
            id: ConnectionTypes.ORDER_EXCHANGE,
            label: (
                <span className='display-flex gap-3 align-items-center'>
                    <span className='rioglyph rioglyph-tms' />
                    <FormattedMessage id='intl-msg:network.label.connectionType.orderExchange' />
                </span>
            ),
            selected: selectedConnectionTypes.includes(ConnectionTypes.ORDER_EXCHANGE),
        },
        {
            id: ConnectionTypes.RENTAL,
            label: (
                <span className='display-flex gap-3 align-items-center'>
                    <span className='rioglyph rioglyph-delivery-completed' />
                    <FormattedMessage id='intl-msg:network.label.connectionType.rental' />
                </span>
            ),
            selected: selectedConnectionTypes.includes(ConnectionTypes.RENTAL),
        },
    ];

    if (restrictedConnectionType) {
        return null;
    }

    return (
        <Multiselect
            id='connectionTypeFilter'
            placeholder={<FormattedMessage id='intl-msg:network.label.selectConnectionType' />}
            options={connectionTypeOptions}
            className='min-width-350'
            onChange={(response: string[]) => {
                setSelectedConnectionTypes(response as ConnectionType[]);
                onConnectionTypeChange(response as ConnectionType[]);
            }}
        />
    );
};

export default ConnectionTypeFilter;
